import { useSelector } from 'react-redux';

import { selectPaymentFormStatus } from '@cashier/cashier-data-access';
import { FormStatuses } from '@cashier/cashier-model';

export const useFormStatus = (): FormStatuses => {
  return useSelector(selectPaymentFormStatus);
};
